import React from "react";

function IconaContatto({
    nomeIcona,
    boolean,
    testoTooltip
}) {
    let classIcona = "nonSelezionabile material-icons colScrittaDef-20"
    if (boolean === 1) {
        classIcona = "nonSelezionabile material-icons scrittaColoreAlt"
    }

    return (
    <div className="tooltip">
        <div className={classIcona}>{nomeIcona}</div>
        <div class="tooltiptext">
            {testoTooltip}
        </div>
    </div>)
}

export default IconaContatto;